module.exports = __webpack_public_path__ + "assets/img/6.9c3efa86.png";